var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankProductAndServiceSolutionForAbroad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3116.000000, -1368.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-Product-and-Service/Solution-for-abroad",
    transform: "translate(3116.000000, 1368.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.98954436,0 C2.81276588,0 3.47908872,0.671 3.47908872,1.5 L3.47908872,1.5 L3.47908872,32 L0.5,32 L0.5,1.5 C0.5,0.671 1.16632284,0 1.98954436,0 Z M26.6252178,15.9145 C27.9707729,14.5585 30.1544449,14.5585 31.5,15.9145 L31.5,15.9145 L21.7504357,25.7325 L19.3135411,28.1875 L16.8756535,25.7325 L10.3762749,19.1875 C11.72183,17.8315 13.904509,17.8315 15.2510571,19.1875 L15.2510571,19.1875 L19.3135411,23.2785 Z M4.80676926,1.0835 C7.56476837,-0.686783019 10.3225465,0.0480514418 13.0803122,0.924685005 L14.0731077,1.24231499 C16.8308733,2.11894856 19.5886515,2.85378302 22.3466506,1.0835 L22.3466506,1.0835 L22.3466506,12.1225 C19.5886515,13.892783 16.8308733,13.1579486 14.0731077,12.281315 L13.0803122,11.963685 C10.3225465,11.0870514 7.56476837,10.352217 4.80676926,12.1225 L4.80676926,12.1225 Z",
    id: 139
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankProductAndServiceSolutionForAbroad);
export default __webpack_public_path__ + "static/media/bank-product-and-service-solution-for-abroad.adf1f863.svg";
export { ForwardRef as ReactComponent };